import { FilterProps } from '@/graphQl/nftList.type';
import { SoldItemCountDetails } from '@/lib/providers/NftContextProvider';

export async function getAllTokens(request: {
  offset: number;
  filter?: FilterProps;
  search?: string;
  tokenIds?: string[];
  soldItems?: SoldItemCountDetails[];
}) {
  try {
    const response = await fetch('/api/getAllTokens', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error calling getAllTokens API:', error);
    throw error;
  }
}

export async function getByTokenId(tokenId: string) {
  const response = await fetch(`/api/getByTokenId?tokenId=${tokenId}`);
  return response.json();
}

export async function getTokenCounts() {
  const response = await fetch('/api/getTokenCounts');
  return response.json();
}
